export class LoadingInfo {
    static defaultValue() {
        return new LoadingInfo(0, 1)
    }

    constructor(loaded, total) {
        this.loaded = loaded
        this.total = total
    }
}